import { render, staticRenderFns } from "./MotorbikeNew.vue?vue&type=template&id=2481f58d&"
import script from "./MotorbikeNew.vue?vue&type=script&lang=js&"
export * from "./MotorbikeNew.vue?vue&type=script&lang=js&"
import style0 from "./MotorbikeNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports